import gql from 'graphql-tag';

export default gql`
  mutation createObservation($input: ObservationInput!) {
    createObservation(input: {observation: $input}) {
        observation {
          questionnaireResponseId
          carePlanId
          patientId
          encounterId
          code
          status
          value
          valueType
        }
        errors {
            path
            message
        }
    }
  }
`;
